import i18n from 'i18next';

export default class I18n {
  static initialize (dictionary, lng = 'en') {
    if (dictionary === this.dictionary) return this;
    const config = {
      lng,
      interpolation: {
        escapeValue: false,
        prefix: '%{',
        suffix: '}',
      },
      resources: {},
    };

    config.resources[lng] = { translation: dictionary };

    i18n.init(config);

    this.i18n = i18n;
    this.dictionary = dictionary;
    return this;
  }

  static prependLanguageCodeToFilename (filename) {
    return `./${this.i18n.language}-${filename}`;
  }
}
